import BaseComponent, { Component, Prop } from '@/mixins/base.component';
import { NotificationEntity } from '@/types/Notification';

import { HIDE_NOTIFICATION } from '../../../store/actions';

@Component({})
export default class NotificationView extends BaseComponent {
   @Prop({ type: Object, required: true }) public notification: NotificationEntity;

   protected hide() {
      this.$store.dispatch(HIDE_NOTIFICATION, this.notification);
   }

   protected remove() {
      this.$store.dispatch(HIDE_NOTIFICATION, this.notification);
   }
}
